/* Product-gallery video behaviour for every product template (loaded by snippets/lnc-pdp-video.liquid,
   which snippets/media.liquid renders next to each gallery video).
   Same logic as the wallart_video_behavior custom-liquid section on the wall art templates; on pages that
   carry that section this file stands down so the two never both run.
   Loading: media.liquid outputs the video with preload="none", so the page downloads no video bytes at
   load - only the poster image. The file is fetched when play() is first called, i.e. when the video
   scrolls/swipes into view or its thumbnail is clicked. */

/* Full-screen viewer that includes the video. The theme's PhotoSwipe lightbox only collects
   `.lightbox-image` photo links, so the video was missing from it (1 / 6 instead of 1 / 7) and the
   instance is private, so it cannot be extended. Instead, clicks on gallery photos are taken over
   here (capture phase, before the theme's listener) and the same PhotoSwipe opens with the theme's
   own options, built from every gallery item in order - the video in its place. A tap on the phone
   carousel's video (which has no native controls) opens it full screen too. Runs on every product
   page, including the wall art ones where the behaviour block below stands down. */
(function () {
  if (window.lncPdpLightbox) return;
  window.lncPdpLightbox = true;

  var ITEM = '.product__media-item:not(.swiper-slide-duplicate)';
  /* native controls only where there is a mouse: on touch screens a <video controls> keeps
     every touch, so the viewer could not be swiped past it */
  var fineInput = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function videoItem(item) {
    var src = item.querySelector('video');
    if (!src) return null;
    var v = src.cloneNode(true);
    ['controls', 'style', 'class', 'id', 'autoplay'].forEach(function (a) { v.removeAttribute(a); });
    v.setAttribute('muted', '');
    v.setAttribute('loop', '');
    v.setAttribute('playsinline', '');
    v.setAttribute('preload', 'auto');
    v.setAttribute('disablepictureinpicture', '');
    v.setAttribute('controlslist', 'nodownload noplaybackrate noremoteplayback');
    if (fineInput) v.setAttribute('controls', '');
    /* size the slide like the poster so PhotoSwipe centres and fits it as it does a photo */
    var ratio = (getComputedStyle(item.querySelector('.media') || item).getPropertyValue('--video-aspect-ratio') || '').split('/');
    var w = parseFloat(ratio[0]) || 3, h = parseFloat(ratio[1]) || 4;
    return { html: '<div class="lnc-pswp-video">' + v.outerHTML + '</div>', width: w, height: h, element: src };
  }

  function imageItem(link) {
    var img = link.querySelector('img');
    return {
      src: link.getAttribute('data-pswp-src') || link.href,
      width: parseInt(link.getAttribute('data-pswp-width'), 10) || 0,
      height: parseInt(link.getAttribute('data-pswp-height'), 10) || 0,
      msrc: img ? (img.currentSrc || img.src) : undefined,
      thumbCropped: link.getAttribute('data-cropped') === 'true',
      element: link
    };
  }

  /* Shopify's asset processing rewrites a literal dynamic import in this file into require(),
     which does not exist in the browser - so the theme's PhotoSwipe chunk is loaded through a
     small injected module script instead (the same file the theme itself imports). */
  var pswpPromise = null;
  function loadPhotoSwipe() {
    if (pswpPromise) return pswpPromise;
    pswpPromise = new Promise(function (resolve, reject) {
      window.__lncPswpReady = resolve;
      var s = document.createElement('script');
      s.type = 'module';
      s.textContent = 'import * as m from ' + JSON.stringify(flu.chunks.photoswipe) + '; window.__lncPswpReady(m);';
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return pswpPromise;
  }

  function open(container, clickedItem, clickedEl) {
    var id = clickedItem.getAttribute('data-media-item-id');
    var items = [], index = 0;
    var nodes = container.querySelectorAll(ITEM);
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i], data = null;
      var link = node.querySelector('.lightbox-image');
      if (link) data = imageItem(link);
      else if (node.getAttribute('data-media-type') === 'video') data = videoItem(node);
      if (!data) continue;
      if (node.getAttribute('data-media-item-id') === id) {
        index = items.length;
        /* a looping carousel may have been showing a clone: zoom from what was actually tapped */
        if (clickedEl) data.element = clickedEl;
      }
      items.push(data);
    }
    if (!items.length || !window.flu || !flu.chunks || !flu.chunks.photoswipe) return false;

    var icons = (window.theme && window.theme.icons) || {};
    loadPhotoSwipe().then(function (mod) {
      var lightbox = new mod.PhotoSwipeLightbox({
        dataSource: items,
        pswpModule: mod.PhotoSwipe,
        showHideAnimationType: 'zoom',
        mainClass: 'pswp--product-lightbox',
        bgOpacity: 1,
        arrowPrevSVG: icons.chevron,
        arrowNextSVG: icons.chevron,
        closeSVG: icons.close,
        zoomSVG: icons.zoom,
        /* phones have no video controls here: when iOS declined to autoplay (Low Power
           Mode) a tap starts the video; otherwise a tap shows/hides the buttons as usual */
        tapAction: function () {
          var slide = this.currSlide;
          var v = slide && slide.container && slide.container.querySelector('.lnc-pswp-video video');
          if (v && v.paused) { playVideo(v); return; }
          this.element.classList.toggle('pswp--ui-visible');
        }
      });
      lightbox.on('firstUpdate', function () {
        if (items.length === 1) lightbox.pswp.element.classList.add('pswp--is-single-image');
      });
      function playVideo(v) {
        if (!v) return;
        v.muted = true;
        if (!v.lncMuteLocked) {
          v.lncMuteLocked = true;
          v.addEventListener('volumechange', function () { if (!v.muted) v.muted = true; });
        }
        try { v.currentTime = 0; } catch (err) {}
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
      /* PhotoSwipe only attaches a non-photo slide after the opening animation ends
         (appendHeavyContent), so when the viewer opens ON the video, contentActivate has already
         passed with nothing on the page. Start it there too, and on every slide change. */
      function playCurrent() {
        var slide = lightbox.pswp && lightbox.pswp.currSlide;
        playVideo(slide && slide.container && slide.container.querySelector('.lnc-pswp-video video'));
      }
      lightbox.on('contentActivate', function (e) {
        playVideo(e.content && e.content.element && e.content.element.querySelector('video'));
      });
      lightbox.on('appendHeavyContent', function (e) {
        if (e.slide && e.slide.isActive) playVideo(e.slide.container.querySelector('.lnc-pswp-video video'));
      });
      lightbox.on('change', playCurrent);
      lightbox.on('contentDeactivate', function (e) {
        var v = e.content && e.content.element && e.content.element.querySelector('video');
        if (v) v.pause();
      });
      lightbox.init();
      lightbox.loadAndOpen(index);
    });
    return true;
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var container = e.target.closest('.lightbox-media-container');
    if (!container) return;
    var item = e.target.closest('.product__media-item');
    if (!item) return;
    var link = e.target.closest('.lightbox-image');
    var phoneVideo = !link && item.getAttribute('data-media-type') === 'video' && item.closest('.below-mobile');
    if (!link && !phoneVideo) return;
    /* a drag that ends on a slide is not a tap: Swiper flags it and suppresses the click */
    var swiperEl = item.closest('.swiper');
    if (swiperEl && swiperEl.swiper && swiperEl.swiper.allowClick === false) return;
    if (open(container, item, link || item.querySelector('video'))) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);
})();

/* The video dot marker (play triangle in the phone carousel dots) is an inline script in
   snippets/lnc-pdp-video.liquid, not here: this file is deferred and ran after the theme had
   already drawn the dots, so a round dot showed first and then swapped. */

(function () {
  if (window.lncPdpVideo) return;
  window.lncPdpVideo = true;
  if (document.querySelector('[id$="__wallart_video_behavior"]')) return;

  /* WeakSets, not attributes: the mobile carousel loops, so Swiper clones slides
     and an attribute flag would be copied onto clones that are not yet wired up */
  var audioLocked = new WeakSet();
  var autoplayBound = new WeakSet();
  var carouselBound = new WeakSet();

  function videoItems() {
    return document.querySelectorAll('.product__media-item[data-media-type="video"]');
  }

  /* tear down the theme's Plyr instance so nothing competes with native controls */
  function removePlyr(item) {
    var video = item.querySelector('video');
    if (video && video.plyr && typeof video.plyr.destroy === 'function') {
      try { video.plyr.destroy(); } catch (err) {}
    }
    /* stop the theme re-initializing it if the gallery re-renders */
    var media = item.querySelector('.media[data-interactive]');
    if (media) media.removeAttribute('data-interactive');
  }

  function enforce(video) {
    if (!video) return;
    video.loop = true;
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    /* required for inline autoplay on iOS, otherwise it refuses or goes fullscreen */
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    /* Phone gallery (.below-mobile carousel): no native controls. On iOS a video with
       controls keeps every touch for itself, so the carousel could not be swiped while
       it played. It autoplays muted and loops anyway; a tap starts it if iOS declined. */
    if (video.closest('.below-mobile')) {
      video.controls = false;
      video.removeAttribute('controls');
    } else if (!video.hasAttribute('controls')) video.setAttribute('controls', '');
    /* strip everything from the overflow menu (download, playback speed, cast) so
       Chrome drops the menu button itself; disablePictureInPicture kills PiP */
    video.setAttribute('controlsList', 'nodownload noplaybackrate noremoteplayback');
    video.disablePictureInPicture = true;
    video.setAttribute('disablepictureinpicture', '');
    if (audioLocked.has(video)) return;
    audioLocked.add(video);
    video.addEventListener('volumechange', function () {
      if (!video.muted || video.volume > 0) {
        video.muted = true;
        video.volume = 0;
      }
    });
    video.addEventListener('play', function () { video.muted = true; });
  }

  function play(video) {
    enforce(video);
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  /* autoplay whenever the video is actually on screen. This covers the mobile
     carousel (inactive slides sit outside the viewport) and the desktop gallery
     (unselected media is display:none), without needing carousel-specific hooks */
  function bindAutoplay(video) {
    if (!window.IntersectionObserver || autoplayBound.has(video)) return;
    autoplayBound.add(video);
    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var entry = entries[i];
        var v = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          try { v.currentTime = 0; } catch (err) {}
          play(v);
        } else if (!v.paused) {
          v.pause();
        }
      }
    }, { threshold: [0, 0.5] });
    observer.observe(video);
  }

  /* Second, independent trigger for the mobile carousel: play whichever video is
     the active slide. IntersectionObserver alone is enough in a normal browser,
     but this also covers the case where the carousel moves without a visibility
     change the observer reports. */
  function bindCarousel() {
    var carousels = document.querySelectorAll('.product__media-container.swiper');
    for (var i = 0; i < carousels.length; i++) {
      var el = carousels[i];
      var swiper = el.swiper;
      if (!swiper || carouselBound.has(swiper)) continue;
      carouselBound.add(swiper);
      (function (root) {
        var sync = function () {
          var vids = root.querySelectorAll('.product__media-item[data-media-type="video"] video');
          for (var j = 0; j < vids.length; j++) {
            var video = vids[j];
            var slide = video.closest('.swiper-slide');
            if (slide && slide.classList.contains('swiper-slide-active')) {
              try { video.currentTime = 0; } catch (err) {}
              play(video);
            } else if (!video.paused) {
              video.pause();
            }
          }
        };
        swiper.on('slideChangeTransitionEnd', sync);
        swiper.on('slideChange', sync);
        sync();
      })(el);
    }
  }

  function sweep() {
    var items = videoItems();
    for (var i = 0; i < items.length; i++) {
      removePlyr(items[i]);
      var video = items[i].querySelector('video');
      enforce(video);
      if (video) bindAutoplay(video);
    }
    bindCarousel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sweep);
  } else {
    sweep();
  }
  /* Plyr is created asynchronously once Shopify's video-ui feature loads, Swiper
     clones slides at init, and the gallery re-renders on variant change */
  [400, 1000, 2000, 4000].forEach(function (ms) { setTimeout(sweep, ms); });
  document.addEventListener('variant:change', sweep);

  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('.product__media-item[data-media-type="video"], .plyr')) { sweep(); return; }
          if (node.querySelector && node.querySelector('.product__media-item[data-media-type="video"], .plyr')) { sweep(); return; }
        }
      }
    });
    /* observe the page, not the galleries: with per-variant media on, a variant change
       re-fetches the product section and REPLACES the galleries, so an observer on the
       original gallery nodes would never see the new video (it would keep native
       controls on phones, keep the theme's Plyr chrome and never autoplay) */
    observer.observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var mediaItem = e.target.closest('.product__media-item[data-media-type="video"]');
    if (mediaItem) {
      var tapped = mediaItem.querySelector('video');
      enforce(tapped);
      /* phone carousel has no controls: a tap plays a video iOS would not autoplay (Low Power Mode) */
      if (tapped && tapped.paused && mediaItem.closest('.below-mobile')) play(tapped);
    }

    var thumb = e.target.closest('[data-product-thumbnail]');
    if (!thumb) return;
    var id = thumb.getAttribute('data-thumbnail-id');
    if (!id) return;
    /* scope to this thumbnail's own gallery: the video also exists in the mobile carousel markup */
    var container = thumb.closest('.product__media-container') || document;
    /* the thumbnail gallery hides unselected media with display:none, which the
       IntersectionObserver does not reliably report - so a video left for an
       image kept playing (muted, off screen). Pause every other video here. */
    var others = container.querySelectorAll('.product__media-item[data-media-type="video"]');
    for (var k = 0; k < others.length; k++) {
      if (others[k].getAttribute('data-media-item-id') === id) continue;
      var ov = others[k].querySelector('video');
      if (ov && !ov.paused) ov.pause();
    }
    var item = container.querySelector('.product__media-item[data-media-item-id="' + id + '"][data-media-type="video"]');
    if (!item) return;
    setTimeout(function () {
      var video = item.querySelector('video');
      if (!video) return;
      removePlyr(item);
      bindAutoplay(video);
      try { video.currentTime = 0; } catch (err) {}
      if (video.paused) play(video);
    }, 50);
  });
})();
